// Vietnamese labels for ActivityLog `action` values. Used by employer's
// /org/activity page and admin's audit feed to show humans-readable rows
// instead of raw dotted codes. Keep in sync with the action strings emitted
// by ActivityLogService callers in apps/api/src.

export const ACTIVITY_ACTION_LABEL_VI: Record<string, string> = {
  // Application
  "application.invited": "Mời ứng viên phỏng vấn",
  "application.rejected": "Từ chối ứng viên",

  // Invite (slot picking lifecycle)
  "invite.accepted": "Ứng viên chấp nhận lời mời",
  "invite.committed": "Ứng viên chốt lịch phỏng vấn",
  "invite.expired": "Lời mời hết hạn",
  "invite.cancelled_in_window": "Huỷ lời mời (trong cửa sổ 30 phút)",
  "invite.cancelled_post_commit": "Huỷ lời mời sau khi đã chốt",
  "invite.rescheduled_in_window": "Đổi lịch (trong cửa sổ 30 phút)",

  // Slot
  "slot.created": "Tạo slot phỏng vấn",

  // Posting
  "posting.created": "Tạo tin tuyển dụng",
  "posting.published": "Đăng tin",
  "posting.updated": "Cập nhật tin",
  "posting.closed": "Đóng tin",
  "posting.cancelled": "Huỷ tin",
  "posting.expired": "Tin hết hạn",
  "posting.deleted": "Xoá tin",

  // Org
  "org.created": "Tạo doanh nghiệp",
  "org.profile_updated": "Cập nhật hồ sơ doanh nghiệp",
  "org.owner_granted": "Trao quyền chủ doanh nghiệp cho tài khoản",

  // Credit (lượt phỏng vấn)
  "credit.granted": "Cấp lượt phỏng vấn",
  "credit.refunded": "Hoàn lượt phỏng vấn",
  "credit.purchase_created": "Tạo đơn mua lượt phỏng vấn",
  "credit.purchase_paid": "Thanh toán lượt phỏng vấn",
  "credit.purchase_cancelled": "Huỷ đơn mua lượt phỏng vấn",
  "credit.purchase_failed": "Thanh toán thất bại",

  // Subscription plans / top-ups
  "plan.purchase_paid": "Thanh toán gói/lượt thành công",
  "plan.granted": "Admin cấp gói",
  "giftcode.redeemed": "Kích hoạt mã quà tặng",

  // Rating
  "rating.given": "Đánh giá",

  // Worker / abuse
  "worker.no_show": "Ứng viên không tới phỏng vấn",
  "user.suspended_contact_leak": "Đình chỉ tài khoản do rò rỉ liên hệ",

  // Admin
  "admin.act_as": "Admin đăng nhập với tư cách người dùng",
};

/**
 * Lookup label for an activity action. Falls back to the raw code so unknown
 * future actions still render something readable (server-side action vocab
 * can outpace this catalog between deploys).
 */
export function formatActivityAction(action: string): string {
  return ACTIVITY_ACTION_LABEL_VI[action] ?? action;
}
